const { SvgIcon } = require("@mui/material");

function ChangeFile(props) {
  return (
    <SvgIcon
      sx={{
        fill: "none",
        "& g": {
          stroke: (theme) => theme.palette.text.primary,
        },
      }}
      width="24px"
      height="24px"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15.8655 20.9874C19.2213 20.9874 21.1984 19.0094 21.1984 15.6546L21.2246 10.9989C21.2246 7.57609 19.983 5.86421 16.6194 5.86421H13.9661C13.2928 5.86227 12.6594 5.54554 12.2542 5.00827L11.3983 3.86961C10.9941 3.33137 10.3607 3.01367 9.68739 3.01367H7.81229C4.45654 3.01367 3.22461 4.99079 3.22461 8.34168V15.6546C3.22461 19.0094 5.20561 20.9874 8.56913 20.9874H15.8655Z"
        stroke={props.color || "#000000"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.14453 12.2286L10.8331 10.5312V16.1692"
        stroke={props.color || "#000000"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.3058 14.4728L13.6172 16.1702V10.5312"
        stroke={props.color || "#000000"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
}

export default ChangeFile;
